import React, { useEffect, useState } from "react";
import "./CategoryModal.css";

export default function CategoryModal({ editData, onClose, onSave }) {
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [orderId, setOrderId] = useState("");

    useEffect(() => {
        if (editData) {
            setName(editData.name);
            setDesc(editData.description);
            setOrderId(editData.orderId);
        } else {
            setName("");
            setDesc("");
            setOrderId("");
        }
    }, [editData]);

    return (
        <div className="overlay">
            <div className="modal">
                <h2>{editData ? "Edit Category" : "Create Category"}</h2>

                <input
                    className="input"
                    placeholder="Category Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <textarea
                    className="textarea"
                    placeholder="Description"
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                />

                <input
                    className="input"
                    placeholder="Order ID"
                    type="number"
                    value={orderId}
                    onChange={(e) => setOrderId(e.target.value)}
                />

                <div className="actions">
                    <button className="btn cancel" onClick={onClose}>
                        Cancel
                    </button>

                    <button
                        className="btn save"
                        onClick={() => {
                            onSave(name, desc, orderId);
                            onClose();
                        }}
                    >
                        {editData ? "Update" : "Create"}
                    </button>
                </div>
            </div>
        </div>
    );
}
